exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-add {\n  width: 1230px;\n  height: 100%;\n  margin: 0 auto;\n}\n.product-add .product-bread {\n  height: 50px;\n  width: 100%;\n  border: 1px solid #e5e5e5;\n  line-height: 50px;\n  padding-left: 30px;\n  background: #ffffff;\n  margin-top: 30px;\n}\n.product-add .product-cont {\n  width: 1230px;\n  margin: auto;\n  margin-top: 20px;\n  background: #ffffff;\n  padding: 30px;\n  border: 1px solid #e5e5e5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/product/edit/index.less
// module id = 1053
// module chunks = 0